import React from 'react';
import './ConversationControls.css';

const ConversationControls = ({ 
  isPlaying, 
  onPlay, 
  onPause, 
  onResume, 
  onReset, 
  playbackSpeed, 
  onSpeedChange,
  onExport,
  currentTime,
  conversationStarted
}) => {
  const handlePlayPause = () => {
    if (isPlaying) {
      onPause();
    } else {
      onResume();
    }
  };

  const getPlayButtonTitle = () => {
    if (!conversationStarted) return "Start AI Debate";
    if (isPlaying) return "Pause Debate";
    return "Resume Debate";
  };

  return (
    <div className="conversation-controls">
      <div className="playback-controls">
        {!conversationStarted ? (
          <button 
            className="control-button play-button"
            onClick={onPlay}
            title="Start AI Debate"
          >
            🎭 Start Debate
          </button>
        ) : (
          <button 
            className="control-button play-button"
            onClick={handlePlayPause}
            title={getPlayButtonTitle()}
          >
            {isPlaying ? '⏸️' : '▶️'}
          </button>
        )}
        
        <button 
          className="control-button reset-button"
          onClick={onReset}
          title="Reset Conversation"
        >
          🔄
        </button>
        
        <div className="speed-controls">
          <button 
            className={`speed-button ${playbackSpeed === 1 ? 'active' : ''}`}
            onClick={() => onSpeedChange(1)}
            title="Normal Speed"
          >
            1x
          </button>
          <button 
            className={`speed-button ${playbackSpeed === 1.5 ? 'active' : ''}`}
            onClick={() => onSpeedChange(1.5)}
            title="1.5x Speed"
          >
            1.5x
          </button>
          <button 
            className={`speed-button ${playbackSpeed === 2 ? 'active' : ''}`}
            onClick={() => onSpeedChange(2)}
            title="2x Speed"
          >
            2x
          </button>
        </div>
        
        <button 
          className="control-button export-button"
          onClick={onExport}
          title="Export Transcript"
        >
          📤
        </button>
      </div>
      
      <div className="time-display">
        <span className="current-time">{currentTime}</span>
      </div>
    </div>
  );
};

export default ConversationControls;
